import { render } from "./fareUpgrade.vue?vue&type=template&id=f9819968&scoped=true"
import script from "./fareUpgrade.vue?vue&type=script&lang=js"
export * from "./fareUpgrade.vue?vue&type=script&lang=js"

import "./fareUpgrade.vue?vue&type=style&index=0&id=f9819968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9819968"]])

export default __exports__